export default __webpack_public_path__ + "static/matthew-769d24cdf8a2d89dd8bea662b6847cce.jpg";